import { Component, OnInit } from "@angular/core";
import { ClientsService } from "./services/clients.service";
import { AuthService } from "src/app/core/services/auth/auth.service";

@Component({
  selector: "app-clients",
  templateUrl: "./clients.component.html",
  styleUrl: "./clients.component.scss",
})
export class ClientsComponent implements OnInit {
  breadCrumbItems: Array<{}> = [];

  //permissoes
  podeEditar = false;

  constructor(private clientsService: ClientsService, private authService: AuthService) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Call center" },
      { label: "Contatos", active: true },
    ];

    this.permissaoAdicionarUsuario();
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Contatos', 'Editar')
  }
}
